export const GAME_440_RIGHT_ICON_PRODUCTS = [
  {
    productId: 'lap.app.pack11',
    cpProductId: '999000903',
    badgeKey: 'v3ProductLimitOnceBadge'
  },
  {
    productId: 'lap.app.pack37',
    cpProductId: '999000901',
    badgeKey: 'v3ProductWeeklyOnlyBadge'
  },
  {
    productId: 'lap.app.pack30',
    cpProductId: '999000902',
    badgeKey: 'v3ProductMonthlyOnlyBadge'
  }
];

export const GAME_454_RIGHT_ICON_PRODUCTS = [
  {
    productId: 'zrr.app.pack4.99',
    cpProductId: '900911001',
    badgeKey: 'v3ProductLimitOnceBadge'
  },
  {
    productId: 'zrr.app.pack49.99',
    cpProductId: '900911002',
    badgeKey: 'v3ProductMonthlyOnlyBadge'
  },
  {
    productId: 'zrr.app.pack99.99',
    cpProductId: '900911003',
    badgeKey: 'v3ProductMonthlyOnlyBadge'
  },
];

function isRightIconProduct(item, products) {
  if (!item) {
    return false;
  }
  return products.some(
    product =>
      product.productId === item.PRODUCT_ID &&
      product.cpProductId === String(item.CP_PRODUCT_ID)
  );
}

function getRightIconBadgeKey(item, products) {
  const matchedProduct = products.find(
    product =>
      product.productId === item?.PRODUCT_ID &&
      product.cpProductId === String(item?.CP_PRODUCT_ID)
  );
  return matchedProduct?.badgeKey || '';
}

export function isGame440RightIconProduct(item) {
  return isRightIconProduct(item, GAME_440_RIGHT_ICON_PRODUCTS);
}

export function getGame440RightIconBadgeKey(item) {
  return getRightIconBadgeKey(item, GAME_440_RIGHT_ICON_PRODUCTS);
}

export function isGame454RightIconProduct(item) {
  return isRightIconProduct(item, GAME_454_RIGHT_ICON_PRODUCTS);
}

export function getGame454RightIconBadgeKey(item) {
  return getRightIconBadgeKey(item, GAME_454_RIGHT_ICON_PRODUCTS);
}

export function isGame440RightIconProductSoldOut(item) {
  return isGame440RightIconProduct(item) && +item?.LIMIT === 0;
}

export function isGame440RightIconProductPinned(item) {
  return isGame440RightIconProduct(item) && +item?.LIMIT > 0;
}

export function sortGame440RightIconProducts(productList, gameId) {
  if (!productList?.length) {
    return productList;
  }

  if (+gameId === 440) {
    const topList = [];
    const middleList = [];
    const bottomList = [];

    productList.forEach(item => {
      if (isGame440RightIconProductPinned(item)) {
        topList.push(item);
      } else if (isGame440RightIconProductSoldOut(item)) {
        bottomList.push(item);
      } else {
        middleList.push(item);
      }
    });

    return [...topList, ...middleList, ...bottomList];
  }

  if (+gameId === 454) {
    const topList = [];
    const restList = [];

    productList.forEach(item => {
      if (isGame454RightIconProduct(item)) {
        topList.push(item);
      } else {
        restList.push(item);
      }
    });

    return [...topList, ...restList];
  }

  return productList;
}

/**
 * 从 REMARK 解析互斥 CP_PRODUCT_ID
 * REMARK 形如: product_2|900900001|dailyGift|900900001，取 | 分割后的第 2 段
 */
export function getGame440MutexCpProductId(item) {
  const remark = item?.REMARK;
  if (remark == null || remark === '') {
    return '';
  }
  const mutexCpProductId = String(remark).split('|')[1];
  if (!mutexCpProductId || mutexCpProductId === '0') {
    return '';
  }
  return mutexCpProductId;
}

/**
 * 读取商品互斥类型 MUTEX_TYPE（CP_PRODUCT_EXT）
 */
export function getGame440MutexType(item) {
  const mutexType = item?.CP_PRODUCT_EXT?.MUTEX_TYPE;
  if (mutexType == null || mutexType === '') {
    return '';
  }
  return String(mutexType);
}

/**
 * 当前商品与购物车是否存在互斥冲突：
 * 1. 当前商品 REMARK[1] 命中购物车某商品的 CP_PRODUCT_ID
 * 2. 当前商品 CP_PRODUCT_ID 命中购物车某商品的 REMARK[1]
 * 3. 当前商品 MUTEX_TYPE 非空，且购物车存在相同 MUTEX_TYPE
 */
export function hasGame440MutexConflict(item, cartList) {
  if (!cartList?.length) {
    return false;
  }

  const mutexCpProductId = getGame440MutexCpProductId(item);
  if (
    mutexCpProductId &&
    cartList.some(
      cartItem => String(cartItem.CP_PRODUCT_ID) === mutexCpProductId
    )
  ) {
    return true;
  }

  const currentCpProductId = item?.CP_PRODUCT_ID
    ? String(item.CP_PRODUCT_ID)
    : '';
  if (
    currentCpProductId &&
    currentCpProductId !== '0' &&
    cartList.some(
      cartItem => getGame440MutexCpProductId(cartItem) === currentCpProductId
    )
  ) {
    return true;
  }

  const mutexType = getGame440MutexType(item);
  if (
    mutexType &&
    cartList.some(cartItem => getGame440MutexType(cartItem) === mutexType)
  ) {
    return true;
  }

  return false;
}


/**
 * 从 REMARK 解析互斥 CP_PRODUCT_ID
 * REMARK 形如: THIRDPAY|product_2|900900001|dailyGift|900900001，取 | 分割后的第 3 段
 */
export function getGame454MutexCpProductId(item) {
  const remark = item?.REMARK;
  if (remark == null || remark === '') {
    return '';
  }
  const mutexCpProductId = String(remark).split('|')?.[2];
  if (!mutexCpProductId || mutexCpProductId === '0') {
    return '';
  }
  return mutexCpProductId;
}

/**
 * 读取商品互斥类型 MUTEX_TYPE（CP_PRODUCT_EXT）
 */
export function getGame454MutexType(item) {
  const mutexType = item?.CP_PRODUCT_EXT?.MUTEX_TYPE;
  if (mutexType == null || mutexType === '') {
    return '';
  }
  return String(mutexType);
}

/**
 * 当前商品与购物车是否存在互斥冲突：
 * 1. 当前商品 REMARK[2] 命中购物车某商品的 CP_PRODUCT_ID
 * 2. 当前商品 CP_PRODUCT_ID 命中购物车某商品的 REMARK[2]
 * 3. 当前商品 MUTEX_TYPE 非空，且购物车存在相同 MUTEX_TYPE
 */
export function hasGame454MutexConflict(item, cartList) {
  if (!cartList?.length) {
    return false;
  }

  const mutexCpProductId = getGame454MutexCpProductId(item);
  if (
    mutexCpProductId &&
    cartList.some(
      cartItem => String(cartItem.CP_PRODUCT_ID) === mutexCpProductId
    )
  ) {
    return true;
  }

  const currentCpProductId = item?.CP_PRODUCT_ID
    ? String(item.CP_PRODUCT_ID)
    : '';
  if (
    currentCpProductId &&
    currentCpProductId !== '0' &&
    cartList.some(
      cartItem => getGame454MutexCpProductId(cartItem) === currentCpProductId
    )
  ) {
    return true;
  }

  // const mutexType = getGame454MutexType(item);
  // if (
  //   mutexType &&
  //   cartList.some(cartItem => getGame454MutexType(cartItem) === mutexType)
  // ) {
  //   return true;
  // }

  return false;
}
